import io from 'services/io';

// if the answer is an empty array, it means that the documents were indexed
export const getDocsIndexationStatus = async (docsIds: string[]) => {
    return await io.post(
        '/internal-api/indexation-status',
        { document_ids: docsIds },
        true,
    );
};

const DOCS_INDEXATION_LIMIT_REQUEST = 10;
// if "0" is returned, then all documents have been indexed
export const getDocsIndexationCount = async (
    docsIds: string[],
    notification?: (count: number) => void,
    requestCounter = 0,
): Promise<number> => {
    const docsIndexationStatus = await getDocsIndexationStatus(docsIds);

    if (requestCounter >= DOCS_INDEXATION_LIMIT_REQUEST) {
        return docsIndexationStatus.length;
    }

    if (docsIndexationStatus.length > 0) {
        notification?.(docsIds.length - docsIndexationStatus.length);

        return await new Promise((resolve) => {
            resolve(
                getDocsIndexationCount(
                    docsIds,
                    notification,
                    requestCounter + 1,
                ),
            );
        });
    }

    return docsIndexationStatus.length;
};
